import { render, staticRenderFns } from "./SellerAddProduct.vue?vue&type=template&id=4a89b86a&scoped=true"
import script from "./SellerAddProduct.vue?vue&type=script&lang=js"
export * from "./SellerAddProduct.vue?vue&type=script&lang=js"
import style0 from "./SellerAddProduct.vue?vue&type=style&index=0&id=4a89b86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89b86a",
  null
  
)

export default component.exports